/*
   微信相关
  操作逻辑请都写在此文件内
 */
import $http from './fetch';
import API from '@/config/api';
// 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
export const onMenuShareAppMessage = (
  {
    title = '表单系统',
    desc = '',
    link = '',
    imgUrl = ''
  }
) => {
  wx.ready(() => {
    wx.onMenuShareAppMessage({
      title,
      desc,
      link,
      imgUrl
    });
  });
};

// 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
export const onMenuShareTimeline = (
  {
    title = '表单系统',
    link = '',
    imgUrl = '',
    success = function () {}
  }
) => {
  wx.ready(() => {
    wx.onMenuShareTimeline({
      title,
      link,
      imgUrl,
      success
    });
  });
};

// 隐藏复制链接按钮
export const hideMenuItems = (
  menuList
) => {
  wx.ready(() => {
    wx.hideMenuItems({
      menuList
    });
  });
};

export const getWechatConfig = async () => {
  const data = {
    href: location.href
  };
  try {
    const wechatJsInfo = (await $http.post(API.GET_TICKET, data)).data;
    return wechatJsInfo;
  } catch (err) {
    throw err;
  }
};

export const initWechat = async (isTry) => {
  const config = await getWechatConfig();
  wx.config({
    ...config,
    // jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems']
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems']
  });
  wx.error(function (res) {
    if (!isTry) {
      location.reload();
      initWechat(true);
    }
  });
};
